import script from "./CustomerPackagingRequirementsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerPackagingRequirementsPanel.vue?vue&type=script&setup=true&lang=js"

import "./CustomerPackagingRequirementsPanel.vue?vue&type=style&index=0&id=6f76dfe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f76dfe6"]])

export default __exports__